// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ApexChart_app-chart-container__NPWi8 {
  background-color: var(--m-card-background-color);
  padding: 0 0 8px 0;
  border-radius: var(--m-border-radius-md);
}
.ApexChart_app-chart-container__header__sH5d5 {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ApexChart_app-chart-container__header__sH5d5 .ApexChart_title__Yg-an {
  font-weight: 500;
  font-size: 14px;
  display: flex;
  color: var(--m-text);
}
.ApexChart_app-chart-container__header__sH5d5 .ApexChart_filter__dropdown__BQQqi {
  border: 1px solid var(--m-border-dropdown);
  border-radius: var(--m-border-radius);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 3px 5px 3px 10px;
  cursor: pointer;
  font-size: 12px;
  color: var(--m-text);
}
.ApexChart_app-chart-container__header__sH5d5 .ApexChart_filter__dropdown__BQQqi svg {
  font-size: 18px;
}

[m-data-theme=dark] .ApexChart_app-chart-container__header__sH5d5 .ApexChart_filter__dropdown__BQQqi {
  color: var(--m-text-light);
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/Charts/ApexChart/ApexChart.module.scss"],"names":[],"mappings":"AAAA;EACI,gDAAA;EAEA,kBAAA;EACA,wCAAA;AAAJ;AAEI;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAR;AAEQ;EACI,gBAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;AAAZ;AAGQ;EACI,0CAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AADZ;AAGY;EACI,eAAA;AADhB;;AAWY;EACI,0BAAA;AARhB","sourcesContent":[".app-chart-container {\n    background-color: var(--m-card-background-color);\n    // box-shadow: var(--m-box-shadow);\n    padding: 0 0 8px 0;\n    border-radius: var(--m-border-radius-md);\n\n    &__header {\n        padding: 8px 16px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        .title {\n            font-weight: 500;\n            font-size: 14px;\n            display: flex;\n            color: var(--m-text);\n        }\n\n        .filter__dropdown {\n            border: 1px solid var(--m-border-dropdown);\n            border-radius: var(--m-border-radius);\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            padding: 3px 5px 3px 10px;\n            cursor: pointer;\n            font-size: 12px;\n            color: var(--m-text);\n\n            svg {\n                font-size: 18px;\n            }\n\n        }\n    }\n}\n\n[m-data-theme='dark'] {\n    .app-chart-container {\n        &__header {\n            .filter__dropdown {\n                color: var(--m-text-light);\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app-chart-container": `ApexChart_app-chart-container__NPWi8`,
	"app-chart-container__header": `ApexChart_app-chart-container__header__sH5d5`,
	"title": `ApexChart_title__Yg-an`,
	"filter__dropdown": `ApexChart_filter__dropdown__BQQqi`
};
export default ___CSS_LOADER_EXPORT___;
